/**
 * @description 公用接口
 */
import { getDictAll } from '/@/api/common'
import { getLocal, saveLocal } from '/@/utils/'

export const useCommonStore = defineStore('common', {
  state: (): any => ({
    dictionary: getLocal('dictionary') || [],
    IMShow: false,
    ruleCheckStatus: getLocal('ruleCheckStatus') || [], // 规则编辑器检查状态
  }),
  actions: {
    setDictionary(data: any) {
      this.dictionary = data
      saveLocal('dictionary', this.dictionary)
    },
    init(success: () => void, fail: () => void) {
      // 按多个类型查询字典
      const p1 = new Promise((resolve, reject) => {
        getDictAll()
          .then((res: any) => {
            const obj = res.data.data
            this.setDictionary(obj)
            resolve(1)
          })
          .catch(() => {
            reject(0)
          })
      })

      Promise.all([p1])
        .then(() => {
          success && success()
        })
        .catch(() => {
          fail && fail()
        })
    },
    setIMShow(data: any) {
      this.IMShow = data
    },
    setCheckStatus(data: any) {
      this.ruleCheckStatus = data
      saveLocal('ruleCheckStatus', this.ruleCheckStatus)
    },
  },
})
